// Error types
export class PasskeyError extends Error {
    code;
    originalError;
    constructor(message, code, originalError) {
        super(message);
        this.code = code;
        this.originalError = originalError;
        this.name = "PasskeyError";
    }
}
export class PasskeyRegistrationError extends PasskeyError {
    constructor(message, code, originalError) {
        super(message, code, originalError);
        this.name = "PasskeyRegistrationError";
    }
}
export class PasskeyAuthenticationError extends PasskeyError {
    constructor(message, code, originalError) {
        super(message, code, originalError);
        this.name = "PasskeyAuthenticationError";
    }
}
export class PasskeyVerificationError extends PasskeyError {
    constructor(message, code, originalError) {
        super(message, code, originalError);
        this.name = "PasskeyVerificationError";
    }
}
